import { NavItems } from "@helpers/navigation";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const AppLogin = (): JSX.Element => {
    const navigate = useNavigate();

    useEffect(() => {
        navigate(NavItems.Login.Landing.path);
    }, []);

    return <></>;
};
